import { CDN_PIVOT } from 'core/constants/endpoints'
import fetchJSONHandleError from 'utils/NET/fetchJSONHandleError'

function getShoppingTip() {
  return fetchJSONHandleError({
    url: `${CDN_PIVOT}/resources/shopping-tip/shopping-tip.json`
  })
}

export default getShoppingTip
